import { graphql, StaticQuery, useStaticQuery } from "gatsby";
import React, { useEffect, useState } from "react";

import ThumsUpIcon from "images/icons/thumbs-up.inline.svg";

import { useTheme } from "../../../context/ThemeContext";
import { useBreakpoint } from "../../../hooks/useBreakpoint";
import SalesTeamCard from "../../cards/salesTeamCard";
import { ConditionalSwiper } from "../../shared/conditionalSwiper";
import ProgramCapacity from "../../shared/programCapacity";
import ProgramRating from "../../shared/programRating";

const Step4 = ({
  innerContainer = "m-auto py-2 w-full sm:w-9/12",
  outerContainer = "px-5 py-6 step-wrapper md:px-16 container mx-auto my-6 md:my-0",
  programs,
  extraDetails = {}
}) => {
  const { currentSiteMeta } = useTheme();
  const [programID, setProgramID] = useState("");
  const [programPopular, setProgramPopular] = useState(false);
  const [programCapacity, setProgramCapacity] = useState("");
  const [isIngoProgram, setIsIngoProgram] = useState(false);

  const breakpoint = useBreakpoint();

  const intlNumber = currentSiteMeta?.contact_details?.international ?? "";

  const message = `
      One of our enrollment managers will be in touch. If you can’t wait to speak to us, you can call us on <br/>
      <a class="font-bold" href="tel:${intlNumber}" title="${intlNumber}" rel="nofollow">
        ${intlNumber}.
      </a>`;

  const { staff, placeholder } = useStaticQuery(graphql`
    query {
      staff: allWpTeamMember(
        filter: {
          geographical: {
            nodes: { elemMatch: { slug: { in: "gvi-calendly" } } }
          }
        }
      ) {
        nodes {
          id
          title
          slug
          teamMembersFields {
            seniorStaffTeamMember
            teamPosition
            memberVideo
            memberLinkedin
          }
          featuredImage {
            node {
              sourceUrl
            }
          }
        }
      }

      placeholder: file(name: { eq: "jerome" }) {
        publicURL
      }
    }
  `);

  const profile_list =
    staff?.nodes?.map((profile) => {
      return {
        id: profile?.slug ?? profile?.id ?? "",
        name: profile?.title ?? "",
        position: profile?.teamMembersFields?.teamPosition ?? "",
        video: profile?.teamMembersFields?.memberVideo ?? "",
        linkedin: profile?.teamMembersFields?.memberLinkedin ?? "",
        seniorStaffTeamMember:
          profile?.teamMembersFields?.seniorStaffTeamMember ?? "",
        image: profile?.featuredImage?.node?.sourceUrl ?? ""
      };
    }) ?? [];

  useEffect(() => {
    // eslint-disable-next-line no-restricted-globals
    const currentUrl = new URL(location);

    const ingoProgram =
      extraDetails?.flex_program ??
      currentUrl.searchParams.get("flex_program") === "true";
    setIsIngoProgram(ingoProgram);

    setProgramID(
      extraDetails?.program_id ??
        currentUrl.searchParams.get("program") ??
        currentUrl.searchParams.get("program_id")
    );
  }, []);

  useEffect(() => {
    if (programID && programs) {
      const theProgram =
        programs
          .filter(
            (program) => parseInt(programID) === parseInt(program.databaseId)
          )
          .shift() ?? [];

      setProgramPopular(theProgram?.acfProgramsMeta?.programPopular ?? false);
      setProgramCapacity(theProgram?.acfProgramsMeta?.programCapacity ?? "");
    }
  }, [programs, programID]);

  return (
    <div className={outerContainer}>
      <div className={innerContainer}>
        <div className={"w-full text-center md:text-left"}>
          <div className="flex justify-center md:justify-between items-center">
            <div
              className={
                "flex flex-col sm:flex-row items-center justify-start gap-3"
              }
            >
              <ThumsUpIcon
                className={`h-9 w-9 shrink-0 text-white fill-white`}
              />
              <h1
                className={`font-light shrink-0 text-white`}
                dangerouslySetInnerHTML={{
                  __html: "Thank you!"
                }}
              />
            </div>
            <div className="hidden lg:block">
              <ProgramRating
                outerContainerClass={"items-end justify-end"}
                ratingIconClass={"fill-white h-5"}
                ratingLogoClass={"fill-white h-5"}
              />
            </div>
          </div>

          {!isIngoProgram && programPopular && programCapacity && (
            <ProgramCapacity
              programCapacityText={"almost_full"}
              outerContainerClass={
                "flex-col md:flex-row justify-center md:justify-start pt-6 pb-3"
              }
              headerTitleClass={"md:!text-white"}
              headerClass={"md:h6 !text-white"}
            />
          )}
          <div
            className={`pt-3 text-base font-normal text-white text-center sm:text-left no-br`}
            dangerouslySetInnerHTML={{ __html: message }}
          />
          <div className="block sm:hidden">
            <ProgramRating
              outerContainerClass={
                "items-end justify-center md:justify-end pt-4 pb-2 md:pt-0"
              }
              ratingIconClass={"fill-white h-5"}
              ratingLogoClass={"fill-white h-5"}
              darkRatingIconClass="h-5 w-auto fill-white"
            />
          </div>

          {profile_list?.length > 0 && (
            <div className="my-10">
              <div className="grid gap-4 grid-cols-1 sm:grid-cols-3 md:grid-cols-3 xl:grid-cols-4">
                <ConditionalSwiper
                  condition={breakpoint === "xs"}
                  slidesPerView={1.25}
                  spaceBetween={25}
                  centeredSlides={false}
                  className="h-full w-full"
                >
                  {profile_list?.map((profile) => (
                    <SalesTeamCard
                      profile={profile}
                      key={"profile-card-" + (profile?.id ?? "")}
                      placeholder={placeholder?.publicURL}
                    />
                  ))}
                </ConditionalSwiper>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
export default Step4;
